<template>
  <el-dropdown class="data-grid-dropdown-cell"
               v-if="configs && configs.length"
               placement="bottom">
    <span class="el-dropdown-link">
      {{cellText || '更多功能'}}<i class="el-icon-arrow-down el-icon--right"></i>
    </span>
    <el-dropdown-menu slot="dropdown"
                      class="data-grid-dropdown-cell-wrap">
      <el-dropdown-item v-for="(config, index) in configs"
                        :key="'dropdown-cell-' + index"
                        :divided="config.divider">
        <CompositeTableActionCell :table-column="config"
                                  v-bind="$attrs"
                                  v-on="$listeners">
        </CompositeTableActionCell>
      </el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import CompositeTableActionCell from '../../elements/grid/CompositeTableActionCell'
export default {
  name: 'DataGridDropdownCell',
  components: {
    CompositeTableActionCell
  },
  props: {
    tableColumn: {
      type: Object,
      required: true
    }
  },
  computed: {
    cell: function () {
      let renderCell = this.tableColumn.renderCell
      if (renderCell) {
        let cellType = renderCell.cellType
        if (cellType) {
          return cellType.cell
        }
      }
    },
    configs: function () {
      let cell = this.cell
      if (cell) {
        let configs = cell.configs
        if (configs) {
          return configs.map(config => {
            // 需要从列中继承的属性
            config.prop = this.tableColumn.prop
            return config
          })
        }
      }
    },
    cellText: function () {
      let cell = this.cell
      if (cell) {
        return cell.cellText
      }
    }
  }
}
</script>

<style lang="scss">
  @use "../../../styles/color" as *;
  .data-grid-dropdown-cell {
    font-size: inherit;
    cursor: pointer;
    .el-dropdown-link {
      position: relative;
      font-size: 12px;
      & > .el-icon--right {
        position: absolute;
        top: 50%;
        transform: scale(.9) translateY(-50%);
      }
    }
  }
  .data-grid-dropdown-cell-wrap {
    &.el-dropdown-menu {
      .el-dropdown-menu__item {
        font-size: 12px;
        line-height: 28px;
        .grid-cell {
          display: block;
          margin: 0 -15px;
          .action-cell {
            display: inline-block;
            padding: 0 15px;
            color: inherit;
            text-decoration: none;
          }
        }
      }
    }
  }
</style>
